module.exports = __webpack_public_path__ + "img/image18.893c75b9.png";